import { render } from "./ProjectsListPage.vue?vue&type=template&id=00896c08&ts=true"
import script from "./ProjectsListPage.vue?vue&type=script&lang=ts"
export * from "./ProjectsListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__